/**
 * Marca a rota atual como NÃO indexável (`noindex, nofollow`) para buscadores e
 * IAs. Use em páginas privadas, transacionais ou utilitárias (login, minhaconta,
 * checkout, cancelamento, bellacloud, reset de senha, preview etc.).
 *
 * Por que `tagPriority`? O default global em `layouts/MetaTags.vue` define
 * `robots/googlebot/bingbot` como indexáveis. Como o `MetaTags` é renderizado
 * como FILHO do layout, o `useHead` dele roda DEPOIS do `<script setup>` da
 * página. No dedupe do unhead (v2), tags com a mesma chave e mesmo peso são
 * resolvidas por ordem de registro (vence a última) — então um override de
 * página com prioridade padrão (100) PERDERIA para o global. Forçando
 * `tagPriority` abaixo de 100, o unhead passa a eleger pelo MENOR peso,
 * independente da ordem — a meta da página vence de forma determinística.
 * (O mesmo `-10` já é usado nas tags Open Graph do `MetaTags.vue`.)
 */
export function useNoIndex() {
  const robots = "noindex, nofollow";
  useHead({
    meta: [
      { name: "robots", content: robots, tagPriority: -10 },
      { name: "googlebot", content: robots, tagPriority: -10 },
      { name: "bingbot", content: robots, tagPriority: -10 },
    ],
  });
}
